// takes '2020-11-06' and converts it to '11/06/20'
export default function formatDateString(dateString) {
  const [year, month, day] = dateString.split('-')
  const shortenedYear = year.substring(2)
  return [month, day, shortenedYear].join('/')
}
